import React from 'react'
import '../styles/article.css'

const EchoesCH9 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 9: Decisions in the Snow</h1>


            <p>The MC stepped onto the stage his voice calm yet underscored with urgency. “The
                judges are currently tallying scores, but we’ve called an emergency meeting with all
                directors in the lobby. We ask that fans and parents remain in their seats until the
                meeting concludes.”</p>
            <p>The announcement sent a ripple of whispers through the auditorium, a wave of
                speculation rising and falling around us. I glanced at my watch. It was 3:00. The next
                division was set to begin shortly, and this competition prided itself on running like
                clockwork. But outside, the storm was rewriting everyone’s plans.</p>
            <p>Cora leaned toward me, breaking the tension. “These choirs are on a whole different
                level than this morning’s. And I thought those were amazing.”</p>

            <p>Barbara, ever confident, chimed in. “Ebony’s choir has this division in the bag. Their
                score will be at least ten points higher than the others.” Her voice carried the kind of
                pride only a mother—or someone who had loved like a mother—could feel.</p>
            <p>We waited, the tension in the room mounting with every passing minute. Finally,
                the MC returned, a card in hand. His expression gave nothing away. “Here are the
                results,” he announced, his voice steady but the weight of the moment
                unmistakable.</p>
            <p>The room collectively held its breath.</p>

            <p>“In fourth place, the choir from Nebraska. In third place, the choir from Illinois. In
                second place, the choir from Wisconsin.”</p>
            <p>Cora’s brow furrowed as she leaned closer to me. “No fifth place? Do you think one
                of the choirs got disqualified?”</p>
            <p>I shrugged, unable to offer an answer. Before I could speak, the MC continued. “For
                the first time in this competition’s history, we have a tie for first place. Both the choir
                from Mississippi and the choir from California have received identical scores in the
                preliminary round.”</p>

            <p>The room erupted in applause, but beside me, Barbara let out a small huff of
                disappointment. “Ebony’s choir deserved to win outright,” she muttered, folding her
                arms. “No contest.”</p>
            <p>The MC raised his hand for silence, a smile breaking across his face. “And the
                outstanding female soloist award goes to... Ebony Batson from Mississippi!”</p>
            <p>Barbara’s face lit up, her pride unmistakable. She clasped her hands together, her
                eyes shimmering with joy. “That’s my girl,” she whispered, her voice swelling with
                emotion. Then, louder, “I knew it! Ebony’s voice is unstoppable.”</p>

            <p>The applause lingered, a wave of celebration and relief. But just as the excitement
                began to settle, the atmosphere shifted. The President of the Grand National Show
                Choir Championship Association, Shirley Silverman, stepped onto the stage. Her
                expression was grave, her presence commanding.</p>
            <p>“Ladies and gentlemen,” she began, her voice steady but tinged with concern. “Due
                to the worsening weather, we are adjusting the schedule. Finals will begin at 6:30,
                with only five choirs advancing instead of eight. Please make your personal
                decisions carefully as conditions outside continue to deteriorate.”</p>
            <p>Her words hung in the air like the snow falling outside. Around us, parents and
                spectators broke into murmurs, debating whether to stay or go. I could feel the
                unease settling over the room like a heavy blanket.</p>

            <p>Cora’s voice broke through the din, tinged with worry. “I took the Metra Green Line
                in, but I planned to drive to Dubuque tonight. I’m not sure what to do.”</p>
            <p>Barbara let out a sigh, her shoulders slumping. “I parked twenty minutes from the
                Red Line. My aunt isn’t going to drive in this weather to pick me up. I’m stuck.” She
                looked up toward the ceiling, her voice softening into a plea. “Oh Lord, tell me what
                I’m supposed to do.”</p>
            <p>I reached out instinctively, placing a hand on both of theirs. “Ladies,” I said, my
                voice firm but kind, “my hotel is just around the corner. It’s a suite with a king bed
                and a pull-out sofa. You’re both welcome to stay with me tonight. I’ve got plenty of
                snacks in the mini-fridge, and we can grab more during the break. We’ll make it
                work.”</p>


            <p>Barbara looked at me, her eyes softening. “Thank you. Count me in. I really don’t
                have another choice. But I appreciate it—more than I can say.”</p>
            <p>Cora smiled, her shoulders relaxing as the tension melted away. “A slumber party? At
                forty-four?” She laughed, shaking her head. “I’ve never been to one. But why not?
                Sounds like the perfect way to spend my vacation.”</p>
            <p>I laughed, a warmth spreading through me that had nothing to do with the room’s
                temperature. “Good. Now we have a plan. And I always like having a plan.”</p>

            <p>Outside, the snow continued to fall, silent and relentless, as the world adjusted itself
                around us. But in that moment, surrounded by new friends, I felt a quiet certainty
                that we’d figure it all out—together.</p>




        </div>
    )
}

export default EchoesCH9